// Go Nails — Mejora Carrito
//
// Este theme usa el flujo estándar de Dawn: cada botón "Agregar al carrito" (en la
// ficha de producto, en las tarjetas de colección, en los relacionados, etc.) es un
// <product-form> que ya agrega el producto vía AJAX (assets/product-form.js). El
// problema es que, con "cart_type" en "Página", Dawn no tiene ningún elemento de
// carrito (ni drawer ni notificación) para mostrar tras agregar, así que su propio
// código hace un window.location al carrito y la página se recarga por completo.
//
// Este script no agrega ningún botón nuevo ni cambia el HTML: usa el cart-notification
// de Dawn (ya presente en el header) solo como "motor" para que el producto se agregue
// sin salir de la página, pero evita que su pop-up se muestre. En su lugar, muestra una
// confirmación breve en el propio botón que el cliente ya usa, igual que en nailpro.cl.
// El ícono del carrito sigue llevando a la página de carrito de siempre (/cart).
(function () {
  var lastSubmitButton = null;

  // Guarda una referencia al botón que se usó para enviar el formulario de "agregar al
  // carrito" (capture:true para adelantarnos a cualquier otro listener del formulario).
  document.addEventListener(
    'submit',
    function (evt) {
      var form = evt.target;
      if (!form || form.getAttribute('data-type') !== 'add-to-cart-form') return;
      lastSubmitButton = form.querySelector('[type="submit"]');
    },
    true
  );

  function showConfirmation(button) {
    if (!button) return;
    var span = button.querySelector('span');
    if (!span) return;
    var original = span.textContent;
    span.textContent = '✓ Agregado';
    setTimeout(function () {
      span.textContent = original;
    }, 1600);
  }

  // Evita que aparezca el pop-up de "Producto agregado" (cart-notification) sin tocar
  // el resto de su funcionamiento: la actualización de secciones (ej. el contador del
  // ícono del carrito) sigue ocurriendo con normalidad, solo que en silencio.
  function silenceCartNotification() {
    var notification = document.querySelector('cart-notification');
    if (!notification || notification.dataset.silenced === 'true') return;
    notification.dataset.silenced = 'true';
    notification.open = function () {};
  }

  silenceCartNotification();
  document.addEventListener('DOMContentLoaded', silenceCartNotification);

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, function (event) {
      if (event && event.source === 'product-form') {
        showConfirmation(lastSubmitButton);
      }
    });
  }
})();
